import React, { useContext, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import ReCAPTCHA from 'react-google-recaptcha';

import Regexp from '../../constants/regexp';
import CommonModal from '../../components/common-modal/CommonModal.component';
import WatchVideoModal from '../../modal-pages/watch-video-modal/WatchVideoModal.component';
import ECupApplyChallengeForm from './ECupApplyChallengeForm.component';
import AppContext from '../../context/app/app.context';

import { registerEventTicketRegistration } from '../../services/e-cup.service';

import './ECup.component.scss';

import eCupHeroImg from '../../assets/images/hero-image-1-stormzy-reads.jpg';
import eCupMiddleLeftImg from '../../assets/images/adidas-newspaper-rgb-green-ad.png';
import eCupMiddleRightImg from '../../assets/images/stomzy-reads.jpg';


const _successMsgsForModal = {
    apply: {
        title: null,
        body: [
            'Thank you for submitting your team. We will review your submission and come back to you shortly to confirm if you have been successful.',
            'Please note we have limited spaces for the competition and cannot guarantee spaces for all entries.'
        ]
    },
    guestList: {
        title: 'YOU’RE IN',
        body: [
            'You will receive an email confirming you are on the guest list for the #Merky FC Cup shortly.',
            'Please note, this email confirmation from us will confirm your space at the event. Without this we cannot guarantee your entry.'
        ]
    }
};

function ECup() {
    const { openModal } = useContext(AppContext);

    /** component will-mount */
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const [isWatchModalOpen, setIsWatchModalOpen] = useState(false);
    const [isRulesModalOpen, setIsRulesModalOpen] = useState(false);
    const [isEventTicketModalOpen, setIsEventTicketModalOpen] = useState(false);
    const [isEventTicketSubmitting, setIsEventTicketSubmitting] = useState(false);
    const [eventTicketFeedback, setEventTicketFeedback] = useState(null);
    const [isApplyChallengeModalOpen, setIsApplyChallengeModalOpen] = useState(false);
    const [eCupFormSubmitted, setECupFormSubmitted] = useState(null);
    const [isEventTicketCaptchaVerified, setIsEventTicketCaptchaVerified] = useState(false);
    const eventTicketReCaptchaRef = useRef(null);

    const eventTicketDefaultValues = { fullName: '', email: '', phoneNumber: '', signupForNews: false };
    const {
        register: registerEventTicket,
        handleSubmit: handleEventTicketSubmit,
        formState: { errors: eventTicketErrors },
        reset: resetEventTicket,
        watch: watchEventTicket
    } = useForm({
        mode: 'onSubmit',
        defaultValues: eventTicketDefaultValues
    });

    const isEventTicketSignupForNews = !!watchEventTicket('signupForNews');

    const closeEventTicketModal = () => {
        setIsEventTicketModalOpen(false);
        resetEventTicket(eventTicketDefaultValues);
        setEventTicketFeedback(null);
        eventTicketReCaptchaRef.current?.reset();
        setIsEventTicketCaptchaVerified(false);
    };

    const showECupSuccessModal = (type) => {
        setECupFormSubmitted(type);
        setTimeout(() => {
            setECupFormSubmitted(null);
        }, 8000);
    };

    const onSubmitEventTicketRegistration = async (data) => {
        try {
            if (isEventTicketSubmitting) {
                return;
            }
            const token = eventTicketReCaptchaRef.current?.getValue();
            eventTicketReCaptchaRef.current?.reset();
            setIsEventTicketCaptchaVerified(false);

            setIsEventTicketSubmitting(true);
            setEventTicketFeedback(null);
            const payload = {
                fullName: data.fullName.trim(),
                email: data.email.trim(),
                phoneNumber: data.phoneNumber.trim(),
                signupForNews: !!data.signupForNews
            };
            if (token) {
                payload.reCaptchaToken = token;
            }
            const apiRes = await registerEventTicketRegistration(payload);
            const response = apiRes.data ?? {};
            const code = response.code;
            const explicitSuccess = code === 'CREATED' || code === 'OK';
            const explicitError = typeof code === 'string' && code.startsWith('E_');
            const httpOk = apiRes.status >= 200 && apiRes.status < 300;

            if (explicitSuccess || (httpOk && !explicitError)) {
                closeEventTicketModal();
                showECupSuccessModal('guestList');
            } else {
                setEventTicketFeedback({
                    type: 'error',
                    message: response?.message || 'Unable to complete registration. Please try again.'
                });
            }
        } catch (err) {
            const msg = err?.response?.data?.message;
            setEventTicketFeedback({
                type: 'error',
                message: typeof msg === 'string' && msg.trim() ? msg : 'Something went wrong. Please try again later.'
            });
        } finally {
            setIsEventTicketSubmitting(false);
        }
    };


    return (
        <div className="e-cup-wrapper">
            <div className='hero-section'>
                {/* <img src={eCupHeroImg} className='hero-img' alt='' /> */}
                {/* <picture>
                    {/ * small size * /}
                    <source media='(max-width: 768px)' srcSet={eCupHeroImg} />
                    {/ * large size * /}
                    <source media='(min-width: 769px)' srcSet={eCupHeroImg} />
                    {/ * set default size * /}
                    <img srcSet={eCupHeroImg} className='hero-img' draggable="false" alt="E-Cup here" />
                </picture> */}
                <img srcSet={eCupHeroImg} className='hero-img' draggable="false" alt="E-Cup here" />
                <div className="hero-actions" role="group">
                    <button type="button" className="hero-action-btn" onClick={() => setIsWatchModalOpen(true)}>
                        WATCH
                    </button>
                    <button type="button" className="hero-action-btn" onClick={() => {
                        setIsApplyChallengeModalOpen(true);
                    }}>
                        APPLY
                    </button>
                    <button type="button" className="hero-action-btn" onClick={() => {
                        setEventTicketFeedback(null);
                        setIsEventTicketModalOpen(true);
                    }}>
                        GUEST LIST
                    </button>
                </div>
            </div>

            <div className='e-cup-spacing'>
                <div className='e-cup-desc'>
                    <p className='description-text text-center'>
                        <span className="e-cup-intro-highlight">#MERKY FC CUP | SUNDAY 31st MAY</span>
                        <br />
                        A celebration of London’s next generation of football talent and a stage for ballers to perform.
                        <br /><br />
                        This year our Next Gen tournament will see the best teams at U12’s boy and U16s girls teams compete, the #Merky FC Cup exhibition game with a lineup of ballers, influencers and football voices and this year to celebrate the World Cup, a 3v3 winner stays on tournament where the winning trio get tickets to New York for the FIFA World Cup 2026.
                    </p>
                </div>

                <div className="middle-image-container">
                    <img src={eCupMiddleLeftImg} alt="Tournament" className="middle-img" draggable="false" />
                    <img src={eCupMiddleRightImg} alt="Tournament" className="middle-img hide-on-mobile" draggable="false" />
                </div>

                <div className="world-cup-section">
                    <h2 className="section-heading">
                        WORLD CUP CALLING
                    </h2>
                    <p className="description-text text-center">
                        We are calling for London best trio of ballers to compete to win tickets to this year’s FIFA World Cup 2026 in New York.
                        <br /><br />
                        Teams compete in a winners-stay-on format. Games are first to 3 goals or decided by the leading team at full time. If a match ends level, it goes straight to a 1v1 decider. No easy games. No second chances. Just pressure football and a chance to prove your trio is the best in the city.
                    </p>
                    <div className="action-buttons">
                        <button className="merky-btn" onClick={() => setIsRulesModalOpen(true)}>
                            <span className="merky-btn-label">RULES</span>
                        </button>
                        <button className="merky-btn" onClick={() => setIsApplyChallengeModalOpen(true)}>
                            <span className="merky-btn-label">APPLY</span>
                        </button>
                    </div>
                </div>

                <div className="schedule-section">
                    <h2 className="section-heading">
                        #MERKY FC CUP SCHEDULE
                    </h2>
                    <div className="schedule-table-wrapper">
                        <table className="schedule-table">
                            <thead>
                                <tr>
                                    <th>EVENT</th>
                                    <th>TIME</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>NEXT GEN</td>
                                    <td>9AM - 1PM</td>
                                </tr>
                                <tr>
                                    <td>3V3 TOURNAMENT</td>
                                    <td>1PM - 3PM</td>
                                </tr>
                                <tr>
                                    <td>#MERKY FC CUP EXHIBITION MATCH</td>
                                    <td>3:30PM - 5:00PM</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="action-buttons" style={{ marginTop: '40px' }}>
                        <button className="merky-btn" onClick={() => openModal('contact')}>CONTACT US</button>
                    </div>
                </div>
            </div>



            <WatchVideoModal
                isOpen={isWatchModalOpen}
                onClose={() => setIsWatchModalOpen(false)}
            />
            {/* rules modal */}
            <CommonModal
                title='TOURNAMENT RULES'
                modalClassName='rules-modal'
                isOpen={isRulesModalOpen}
                onClose={() => setIsRulesModalOpen(false)}
            >
                <div className='rules-modal-content'>
                    <h3>3v3 TOURNAMENT RULES</h3>
                    <p className='rules-modal-text'>
                        This is fast, sharp, high-pressure football. Every match starts with a ball drop, and from there it is straight into action. Teams have a 30-second shot clock to keep the game moving, so no time-wasting, no hiding, and no playing safe. First team to score 3 goals wins.
                    </p>
                    <p className='rules-modal-text'>
                        Each match is played 3v3, with 3 minutes per half and a 1-minute half-time break. The winning team stays on the pitch and keeps defending their spot.
                    </p>
                    <p className='rules-modal-text'>
                        There are no corners and no kick-ins — the game is built to flow. Fouls may result in players being sent to the sin bin, giving the other team a chance to take control. If a match ends in a draw, it goes straight to a 1v1 decider to crown the winner.
                    </p>
                    <h4>RULES</h4>
                    <ul className='rules-modal-list'>
                        <li className='rules-modal-list-item'>Ball drop start</li>
                        <li className='rules-modal-list-item'>30 sec shot clock</li>
                        <li className='rules-modal-list-item'>Sin bin for fouls</li>
                        <li className='rules-modal-list-item'>Draw → 1v1</li>
                        <li className='rules-modal-list-item'>No corners</li>
                        <li className='rules-modal-list-item'>No kick-ins</li>
                    </ul>
                    <h4>FORMAT + TIMINGS</h4>
                    <ul className='rules-modal-list'>
                        <li className='rules-modal-list-item'>3v3</li>
                        <li className='rules-modal-list-item'>3 mins per half</li>
                        <li className='rules-modal-list-item'>1 min halftime</li>
                        <li className='rules-modal-list-item'>3 goals for the win</li>
                        <li className='rules-modal-list-item'>Winners stay on</li>
                        <li className='rules-modal-list-item'>Men’s + women’s split (1 hour each)</li>
                    </ul>
                </div>
            </CommonModal>
            {/* event ticket modal */}
            <CommonModal
                title='REGISTER FOR GUEST LIST'
                modalClassName='event-ticket-modal'
                isOpen={isEventTicketModalOpen}
                onClose={closeEventTicketModal}
            >
                <form className='event-ticket-modal-form' autoComplete="off"
                    onSubmit={handleEventTicketSubmit(onSubmitEventTicketRegistration)}
                >
                    {eventTicketFeedback && (
                        <div
                            className={`event-ticket-modal-feedback event-ticket-modal-feedback--${eventTicketFeedback.type}`}
                            role='alert'
                        >
                            <span className='event-ticket-modal-feedback-eyebrow'>
                                {eventTicketFeedback.type === 'success' ? 'Success' : 'Error'}
                            </span>
                            <p className='event-ticket-modal-feedback-text'>
                                {eventTicketFeedback.message}
                            </p>
                        </div>
                    )}
                    <div className='event-ticket-modal-form-item'>
                        <input type='text' placeholder='full name'
                            className='event-ticket-modal-form-item-input-field'
                            {...registerEventTicket('fullName', {
                                required: 'Full name is required.',
                                validate: (value) => (value?.trim() ? true : 'Full name is required.')
                            })}
                        />
                        {eventTicketErrors?.fullName && (
                            <h4 className='event-ticket-modal-form-item-input-err-msg'>
                                {eventTicketErrors.fullName.message}
                            </h4>
                        )}
                    </div>

                    <div className='event-ticket-modal-form-item'>
                        <input type='text' placeholder='email'
                            className='event-ticket-modal-form-item-input-field'
                            {...registerEventTicket('email', {
                                required: 'Email is required.',
                                pattern: {
                                    value: Regexp._EMAIL,
                                    message: 'Please enter a valid e-mail address.'
                                },
                                validate: (value) => (value?.length > 254 ? 'An email address must not exceed 254 characters.' : true)
                            })}
                        />
                        {eventTicketErrors?.email && (
                            <h4 className='event-ticket-modal-form-item-input-err-msg'>
                                {eventTicketErrors.email.message}
                            </h4>
                        )}
                    </div>

                    <div className='event-ticket-modal-form-item'>
                        <input type='text' placeholder='contact number'
                            className='event-ticket-modal-form-item-input-field'
                            {...registerEventTicket('phoneNumber', {
                                required: 'Contact Number is required.',
                                pattern: {
                                    value: Regexp._MOBILE_NUMBER,
                                    message: 'Please enter valid contact number.'
                                }
                            })}
                        />
                        {eventTicketErrors?.phoneNumber && (
                            <h4 className='event-ticket-modal-form-item-input-err-msg'>
                                {eventTicketErrors.phoneNumber.message}
                            </h4>
                        )}
                    </div>

                    <div className='event-ticket-modal-recaptcha'>
                        <ReCAPTCHA ref={eventTicketReCaptchaRef}
                            sitekey={process.env.REACT_APP_SITE_KEY}
                            onChange={(value) => setIsEventTicketCaptchaVerified(!!value)}
                            onExpired={() => setIsEventTicketCaptchaVerified(false)}
                        />
                    </div>

                    <div className='event-ticket-modal-form-item event-ticket-modal-signup-row'>
                        <div className='event-ticket-modal-signup-inner'>
                            <div className='event-ticket-modal-signup-checkbox'>
                                <label htmlFor='event-ticket-signup-for-news'>
                                    {isEventTicketSignupForNews ? (
                                        <svg className='event-ticket-modal-signup-checkbox-icon' width='34' height='34' viewBox='0 0 162 162' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                                            <g>
                                                <path d='M132.319 0H29.6772L0 29.6772V132.319L29.6772 161.933H132.319L161.933 132.319V29.6772L132.319 0Z' fill='#DAFF00' />
                                                <path d='M123.687 44.5474H115.243L65.4032 94.3875L46.8156 75.7368H38.2463L33.0796 80.9036V89.3468L61.1186 117.386H69.6248L128.664 58.2203L128.727 56.9602C128.79 54.6288 128.79 53.3056 128.79 51.0373V49.7141L123.687 44.5474Z' fill='#282727' />
                                            </g>
                                        </svg>
                                    ) : (
                                        <svg className='event-ticket-modal-signup-checkbox-icon' width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                                            <path d='M27.7592 0H6.25409L0 6.25409V27.7592L6.25409 34H27.7592L34 27.7592V6.25409L27.7592 0ZM8.34762 28.9119L5.08808 25.6524V8.34762L8.34762 5.08808H25.6391L28.8987 8.34762V25.6391L25.6391 28.8987H8.34762V28.9119Z' fill='#B3B4B4' />
                                        </svg>
                                    )}
                                </label>
                                <input type='checkbox' id='event-ticket-signup-for-news'
                                    className='event-ticket-modal-signup-checkbox-input'
                                    {...registerEventTicket('signupForNews')}
                                />
                            </div>
                            <p className='event-ticket-modal-signup-copy'>
                                Sign up for news, exclusives and more from Stormzy. Emails will be sent by or on behalf of
                                Universal Music Operations Ltd. You may withdraw your consent at any time. See Privacy Policy at{' '}
                                <a href='https://privacy.umusic.com/uk/' target='_blank'
                                    rel='noopener noreferrer'
                                    className='event-ticket-modal-signup-link'
                                >
                                    https://privacy.umusic.com/uk/
                                </a>
                                .
                            </p>
                        </div>
                    </div>

                    <div className='event-ticket-modal-form-action'>
                        <button className='event-ticket-modal-form-submit-btn'
                            type='submit' disabled={isEventTicketSubmitting || !isEventTicketCaptchaVerified}
                        >
                            {isEventTicketSubmitting ? 'Submitting...' : 'Secure your place'}
                        </button>
                    </div>
                </form>
            </CommonModal>
            {/* e-cup and 3v3 tournament form submitted modal */}
            <CommonModal
                modalClassName='e-cup-modal-success'
                isOpen={!!eCupFormSubmitted}
                onClose={() => setECupFormSubmitted(null)}
            >
                {eCupFormSubmitted && (
                    <div className='e-cup-form-submitted-wrapper'>
                        <div className='e-cup-form-submitted' onClick={() => setECupFormSubmitted(null)}>
                            {_successMsgsForModal[eCupFormSubmitted]?.title && (
                                <h4 className='e-cup-form-submitted-title'>
                                    {_successMsgsForModal[eCupFormSubmitted].title}
                                </h4>
                            )}
                            <div className='e-cup-form-submitted-text'>
                                {_successMsgsForModal[eCupFormSubmitted]?.body.map((paragraph) => (
                                    <p key={paragraph}>{paragraph}</p>
                                ))}
                            </div>
                            <button className='e-cup-form-submitted-close-btn' onClick={() => setECupFormSubmitted(null)}>
                                Ok
                            </button>
                        </div>
                    </div>
                )}
            </CommonModal>
            {/* apply challenge modal */}
            <CommonModal title='APPLY FOR THE 3V3 FOOTBALL TOURNAMENT'
                modalClassName='apply-challenge-modal'
                isOpen={isApplyChallengeModalOpen}
                onClose={() => setIsApplyChallengeModalOpen(false)}
            >
                <ECupApplyChallengeForm
                    onClose={() => setIsApplyChallengeModalOpen(false)}
                    onSuccess={() => showECupSuccessModal('apply')}
                />
            </CommonModal>
        </div>
    );
}


export default ECup;